import { render, staticRenderFns } from "./dailyDepositAffTab.vue?vue&type=template&id=6b182700&lang=pug"
import script from "./dailyDepositAffTab.vue?vue&type=script&lang=js"
export * from "./dailyDepositAffTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports